export const PROGRAM_NODES = [
  {
    key: "trials",
    type: "trials",
    badge: "Trials",
    name: "Trials",
    caption: "Определите уровень студента",
    image: "/program/levels/trials-kickoff.png",
    x: 8,
    y: 46,
    scale: 1.04,
    captionWidth: 132,
  },
  {
    key: "level-0",
    type: "level",
    levelIndex: 0,
    badge: "Level 0",
    name: "Pre-k",
    caption: "Первые шаги в английском",
    image: "/program/levels/level-0-prek.png",
    x: 27,
    y: 27,
    scale: 1.02,
    captionWidth: 140,
  },
  {
    key: "level-1",
    type: "level",
    levelIndex: 1,
    badge: "Level 1",
    name: "Juniors",
    caption: "Весёлые уроки и первые фразы",
    image: "/program/levels/level-1-juniors.png",
    x: 44,
    y: 24,
    scale: 1.06,
    captionWidth: 150,
  },
  {
    key: "level-2",
    type: "level",
    levelIndex: 2,
    badge: "Level 2",
    name: "Starters",
    caption: "Читаем, пишем и понимаем",
    image: "/program/levels/level-2-starters.png",
    x: 66,
    y: 30,
    scale: 1.02,
    captionWidth: 140,
  },
  {
    key: "level-3",
    type: "level",
    levelIndex: 3,
    badge: "Level 3",
    name: "Movers",
    caption: "Говорим увереннее, расширяем словарь",
    image: "/program/levels/level-3-movers.png",
    x: 19,
    y: 79,
    scale: 1.02,
    captionWidth: 150,
  },
  {
    key: "level-4",
    type: "level",
    levelIndex: 4,
    badge: "Level 4",
    name: "Flyers",
    caption: "Свободное общение и сложные темы",
    image: "/program/levels/level-4-flyers.png",
    x: 47,
    y: 75,
    scale: 1.02,
    captionWidth: 150,
  },
  {
    key: "level-5",
    type: "level",
    levelIndex: 5,
    badge: "Level 5",
    name: "Chat Masters",
    caption: "Мастер общения на английском",
    image: "/program/levels/level-5-chat-masters.png",
    x: 68,
    y: 79,
    scale: 1.02,
    captionWidth: 150,
  },
  {
    key: "level-6",
    type: "level",
    levelIndex: 6,
    badge: "Level 6",
    name: "World Talkers",
    caption: "Свободный английский на любые темы",
    image: "/program/levels/level-6-world-talkers.png",
    x: 86,
    y: 73,
    scale: 1.02,
    captionWidth: 150,
  },
  {
    key: "finale",
    type: "finale",
    name: "",
    caption: "",
    image: "/program/levels/finale-castle.png",
    x: 92,
    y: 23,
    scale: 1.28,
  },
];

/** Stone path through level islands (percent coords). Trials and finale castle are not on this path. */
export const PROGRAM_MAIN_PATH =
  "M 27 27 C 34 25, 39 24, 44 24 S 58 27, 66 30 C 79 33, 81 46, 70 55 C 57 65, 36 71, 19 79 M 19 79 C 29 76, 38 75, 47 75 S 61 77, 68 79 S 80 77, 86 73";
